export const initSelectableCard = container => {
    const cards = container.querySelectorAll('.selectable-card');

    const selectCard = card => {
        cards.forEach(sibling => sibling.classList.remove('selected'));
        card.classList.add('selected');

        const radio = card.querySelector('input[type="radio"]');
        if (radio) {
            radio.checked = true;
        }

        const targetId = card.dataset.toggleTarget;

        cards.forEach(sibling => {
            const siblingTargetId = sibling.dataset.toggleTarget;
            if (!siblingTargetId) {
                return;
            }

            const panel = document.getElementById(siblingTargetId);
            if (!panel) {
                return;
            }

            panel.classList.toggle('hidden', siblingTargetId !== targetId);
        });

        container.dispatchEvent(new CustomEvent('card-toggled', {
            bubbles: true,
            detail: {
                value: radio?.value,
                card: card,
            },
        }));
    };

    cards.forEach(card => {
        if (card.querySelector('input[type="radio"]')?.disabled) {
            return;
        }

        card.addEventListener('click', () => selectCard(card));
    });
};
